import { gql } from '@apollo/client'

export const FIND_ALL_STUDY_NOTE_GROUP = gql`
  query findAllStudyNoteGroup($query: StudyNoteGroupQueryInput = {}) {
    findAllStudyNoteGroup(query: $query) {
      count
      items {
        id
        title
        description
        color
        order
        icon
      }
    }
  }
`

export const CREATE_STUDY_NOTE_GROUP = gql`
  mutation createStudyNoteGroup($createStudyNoteGroupInput: CreateStudyNoteGroupInput!) {
    createStudyNoteGroup(createStudyNoteGroupInput: $createStudyNoteGroupInput) {
      id
      title
      description
      color
      order
      icon
    }
  }
`

export const REMOVE_STUDY_NOTE_GROUP = gql`
  mutation removeStudyNoteGroup($removeStudyNoteGroupId: String!) {
    removeStudyNoteGroup(id: $removeStudyNoteGroupId) {
      affected
    }
  }
`

export const UPDATE_STUDY_NOTE_GROUP = gql`
  mutation updateStudyNoteGroup($updateStudyNoteGroupInputFieldName: UpdateStudyNoteGroupInput!) {
    updateStudyNoteGroup(updateStudyNoteGroupInputFieldName: $updateStudyNoteGroupInputFieldName) {
      id
    }
  }
`

export const BULK_UPDATE_STUDY_NOTE_GROUP = gql`
  mutation bulkUpdateStudyNoteGroup($bulkUpdateStudyNoteGroupInput: [BulkUpdateStudyNoteGroupInput!]!) {
    bulkUpdateStudyNoteGroup(bulkUpdateStudyNoteGroupInput: $bulkUpdateStudyNoteGroupInput) {
      id
    }
  }
`

export const BULK_REMOVE_STUDY_NOTE_GROUP = gql`
  mutation bulkRemoveStudyNoteGroup($ids: [LinkStudyNoteGroupInput!]!) {
    bulkRemoveStudyNoteGroup(ids: $ids) {
      affected
    }
  }
`
